document.addEventListener('DOMContentLoaded',()=>{
  const toggle=document.querySelector('[data-mobile-toggle]');
  const nav=document.querySelector('[data-mobile-nav]');
  if(toggle&&nav){
    toggle.addEventListener('click',()=>{const open=nav.classList.toggle('is-open');toggle.setAttribute('aria-expanded',String(open));});
    nav.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{nav.classList.remove('is-open');toggle.setAttribute('aria-expanded','false');}));
  }
  document.querySelectorAll('[data-scroll]').forEach(a=>a.addEventListener('click',e=>{const el=document.querySelector(a.getAttribute('href'));if(el){e.preventDefault();el.scrollIntoView({behavior:'smooth'});}}));

  const toast=(title,sub='Added to your bag')=>{
    let el=document.querySelector('.cart-toast');
    if(!el){el=document.createElement('div');el.className='cart-toast';el.innerHTML='<b class="cart-toast__icon">✓</b><div><strong></strong><span></span></div>';document.body.appendChild(el);}
    el.querySelector('strong').textContent=title;el.querySelector('span').textContent=sub;
    requestAnimationFrame(()=>el.classList.add('is-visible'));
    clearTimeout(window.__rrToast);window.__rrToast=setTimeout(()=>el.classList.remove('is-visible'),2400);
  };

  // Keep product-page variant ID synchronized with option selections.
  document.querySelectorAll('form[data-product-form], form[action*="/cart/add"]').forEach(form=>{
    const variantInput=form.querySelector('[data-variant-id]');
    const variantData=form.parentElement?.querySelector('[data-product-variants]');
    if(variantInput&&variantData){
      let variants=[];try{variants=JSON.parse(variantData.textContent||'[]');}catch(e){variants=[];}
      const selects=[...form.querySelectorAll('[data-option-position]')];
      const sync=()=>{
        if(!selects.length)return;
        const values=selects.map(s=>s.value);
        const match=variants.find(v=>v.options.every((value,i)=>value===values[i]));
        if(match){variantInput.value=match.id;const button=form.querySelector('.add-btn');if(button){button.disabled=!match.available;button.innerHTML=match.available?'Add to bag <span>↗</span>':'Sold out';}}
      };
      selects.forEach(s=>s.addEventListener('change',sync));sync();
    }
  });

  // Fast, reliable Shopify Ajax add-to-cart for product page and quick-add cards.
  document.querySelectorAll('form[action*="/cart/add"]').forEach(form=>{
    form.addEventListener('submit',async e=>{
      if(form.dataset.noAjax==='true')return;
      e.preventDefault();
      const button=form.querySelector('button[type="submit"]');
      if(button){button.classList.add('is-loading');button.disabled=true;}
      try{
        const data=new FormData(form);
        const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{method:'POST',headers:{Accept:'application/json'},body:data});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||result.message||'Unable to add this item');
        toast(result.product_title||'Product added');
        try{const cart=await fetch(`${window.Shopify?.routes?.root||'/'}cart.js`).then(r=>r.json());document.querySelectorAll('[data-cart-count]').forEach(el=>{el.textContent=cart.item_count;el.classList.add('cart-count-pop');setTimeout(()=>el.classList.remove('cart-count-pop'),350);});}catch(_){ }
      }catch(err){alert(err.message||'Unable to add this item to your bag.');}
      finally{if(button){button.classList.remove('is-loading');button.disabled=false;}}
    });
  });
});

/* V5 quick-add: reliable Shopify AJAX add */
document.addEventListener('submit', async function(e){
  const form=e.target;
  if(!form.classList.contains('quick-add-form')) return;
  e.preventDefault();
  const btn=form.querySelector('button');
  if(!btn || btn.disabled) return;
  const original=btn.innerHTML;
  btn.disabled=true;
  btn.classList.add('is-loading');
  btn.innerHTML='<span>Adding…</span><span aria-hidden="true">•</span>';
  try{
    const data=new FormData(form);
    const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:data});
    if(!response.ok) throw new Error('Cart add failed');
    await response.json();
    btn.innerHTML='<span>Added to bag</span><span aria-hidden="true">✓</span>';
    btn.classList.add('is-added');
    document.dispatchEvent(new CustomEvent('cart:updated'));
    setTimeout(()=>{btn.innerHTML=original;btn.classList.remove('is-added');btn.disabled=false;},1300);
  }catch(err){
    console.error(err);
    btn.innerHTML='<span>Try again</span><span aria-hidden="true">↻</span>';
    setTimeout(()=>{btn.innerHTML=original;btn.disabled=false;},1500);
  }
});
